import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
// import Header from "../HeaderV2";
import Footer from "../Footer";
// import { ListMenuIcon, ListMenuReact } from "../MenuV2";
import ThongBaoCapNhapContainer from "containers/Common/ThongBao/ThongBaoCapNhapContainer";
import userApi from "../../service/userApi";
import CauHinhApi from "../../service/cauHinhApi";
import { Cookies } from "react-cookie";
import config from "../../constants/configs";
// import CacheBuster from 'react-cache-buster';
import { version } from "../../../package.json";
import HeaderV2 from "common/HeaderV2";
import { ListMenuReact, ListMenuIcon } from "common/MenuV2";

const LayoutV2 = (props) => {
  const cookies = new Cookies();
  const [isScrolled, setScroll] = useState(window.scrollY > 30);
  const [lstMenuAll, setlstMenuAll] = useState([]);
  const [lstMenu1, setlstMenu1] = useState([]);
  const [lstMenu2, setlstMenu2] = useState([]);
  const [lstMenu3, setlstMenu3] = useState([]);
  let {
    quanlycuahang,
    getComboCuaHang,
    chuyenCuaHang,
    thongTinCuaHangHienTai,
    user,
    getCurrentUser,
    getMenu,
    menu,
    getBadgeMenu,
    getListThongBao,
    thongbao,
  } = props;
  let {
    listCuaHang,
    ComboCuaHangLoaded,
    thongTinCuaHang,
    chuyenCuaHangLoading,
  } = quanlycuahang ? quanlycuahang : {};
  let year = new Date().getFullYear();
  useEffect(() => {
    getBadgeMenu();
    // getMenu();
    thongTinCuaHangHienTai();
    getComboCuaHang();
    getCurrentUser();
    getListThongBao();
    userApi.getAllRole().then((response) => {
      if (response.status == 200) {
        setlstMenuAll(response.data);
        if (response.data.length > 0) {
          var objMenu1 = response.data.filter(
            (e) =>
              e.Code === "trangchu" ||
              e.Code === "nophaithu" ||
              e.Code === "dongtiennhanh" ||
              e.Code === "camdo" ||
              e.Code === "laingay" ||
              e.Code === "laiho" ||
              e.Code === "banhangtragop"
          );
          setlstMenu1(objMenu1);
          var objMenu3 = response.data.filter(
            (e) =>
              e.Code === "quantrihethong" ||
              e.Code === "baocao" ||
              e.Code === "thongke"
          );
          setlstMenu3(objMenu3);
          var objMenu2 = response.data.filter(
            (e) =>
              e.Code !== "trangchu" &&
              e.Code !== "nophaithu" &&
              e.Code !== "dongtiennhanh" &&
              e.Code !== "camdo" &&
              e.Code !== "laingay" &&
              e.Code !== "laiho" &&
              e.Code !== "quantrihethong" &&
              e.Code !== "baocao" &&
              e.Code !== "thongke" &&
              e.Code !== "banhangtragop"
          );
          setlstMenu2(objMenu2);
        }
      }
    });
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const Y = window.scrollY;
    setScroll(Y > 30);
  };
  const chuyenCuaHangHH = (macuahang) => () => {
    chuyenCuaHang({ macuahang });
  };
  if (chuyenCuaHangLoading === false) {
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  let { currentUser } = user ? user : {};
  let { objMenu, objBadgeMenu } = menu;

  let { List, Total, NotiId } = thongbao.objListThongBao;
  let isShowNoti = NotiId !== 0 && NotiId !== null && NotiId !== undefined;
  const currentURL = window.location.href;

  //alert(currentURL);
  return (
    <Fragment>
      <HeaderV2
        className="pt-10"
        showBackground={isScrolled}
        list={listCuaHang}
        onChange={chuyenCuaHangHH}
        thongTin={thongTinCuaHang}
        userInfo={currentUser}
        thongBao={thongbao.objListThongBao}
      />
      <div
        className="main-menu menu-fixed menu-light menu-accordion menu-shadow "
        data-scroll-to-active="true"
      >
        <div className="main-menu-content">
          <ul
            className="nav navigation navbar-nav"
            id="main-menu-navigation4"
            data-menu="menu-navigation"
          >
            <li className="nav-item d-none d-md-block logo-small">
              <a
                class="nav-link nav-menu-main menu-toggle hidden-xs navi-menu backgroundColorFFF"
                href="#"
              >
                <span className="menu-title" style={{ marginRight: "85px" }}>
                  <img
                    class=""
                    style={{ marginTop: "-10px" }}
                    alt="modern admin logo"
                    src="/app-assets/images/logo/logo_morman.png"
                  />
                </span>
                <i
                  className="fa-solid fa-bars"
                  style={{ color: "#FFF", marginLeft: "0px" }}
                ></i>
              </a>
            </li>
          </ul>

          <ul
            className="navigation navigation-main"
            id="main-menu-navigation"
            data-menu="menu-navigation"
          >
            {lstMenu1 &&
              lstMenu1.map((item) => (
                <li
                  className={
                    "nav-item" +
                    (item.IsShowCap2 == true ? " has-sub" : "") +
                    (item.Url == currentURL ? "open active" : "")
                  }
                  key={item.Code}
                >
                  <a href={item.Url === "" ? "#" : item.Url}>
                    <i className={item.Icon}></i>
                    <span className="menu-title">{item.Name} </span>

                    {objBadgeMenu[item.Code] ? (
                      <span class="badge badge badge-info badge-pill float-right mr-2">
                        {objBadgeMenu[item.Code]}
                      </span>
                    ) : (
                      ""
                    )}
                  </a>
                  {item.IsShowCap2 == true && (
                    <ul className="menu-content">
                      {item.lstChild.map((itemSub, index) => (
                        <li
                          key={itemSub.Code + index}
                          className={
                            itemSub.Url == currentURL ? "open active" : ""
                          }
                        >
                          <a className="menu-item" href={itemSub.Url}>
                            <i className={"fas fa-caret-right"}></i>
                            <span className="menu-title">{itemSub.Name}</span>
                            {/* {objBadgeMenu[itemSub.code] ? (
                              <span class="badge badge badge-info badge-pill float-right mr-2">
                                {objBadgeMenu[itemSub.code]}
                              </span>
                            ) : (
                              ""
                            )} */}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            <div class="dropdown-divider-menu"></div>
            {lstMenu2 &&
              lstMenu2.map((item) => (
                <li
                  className={
                    "nav-item" +
                    (item.IsShowCap2 == true ? " has-sub" : "") +
                    (item.Url == currentURL ? "open active" : "")
                  }
                  key={item.code}
                >
                  <a href={item.Url === "" ? "#" : item.Url}>
                    <i className={item.Icon}></i>
                    <span className="menu-title">{item.Name} </span>
                    {/* {objBadgeMenu[item.code] ? (
                      <span class="badge badge badge-info badge-pill float-right mr-2">
                        {objBadgeMenu[item.code]}
                      </span>
                    ) : (
                      ""
                    )} */}
                  </a>
                  {item.IsShowCap2 == true && (
                    <ul className="menu-content">
                      {item.lstChild.map((itemSub, index) => (
                        <li
                          key={itemSub.Code + index}
                          className={
                            itemSub.Url == currentURL ? "open active" : ""
                          }
                        >
                          <a className="menu-item" href={itemSub.Url}>
                            <i className={"fas fa-caret-right"}></i>
                            <span className="menu-title">{itemSub.Name} </span>
                            {/* {objBadgeMenu[itemSub.code] ? (
                              <span class="badge badge badge-info badge-pill float-right mr-2">
                                {objBadgeMenu[itemSub.code]}
                              </span>
                            ) : (
                              ""
                            )} */}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}{" "}
            <div class="dropdown-divider-menu"></div>
            {lstMenu3 &&
              lstMenu3.map((item) => (
                <li
                  className={
                    "nav-item" +
                    (item.IsShowCap2 == true ? " has-sub" : "") +
                    (item.Url == currentURL ? "open active" : "")
                  }
                  key={item.code}
                >
                  <a href={item.Url === "" ? "#" : item.Url}>
                    <i className={item.Icon}></i>
                    <span className="menu-title">{item.Name} </span>
                    {/* {objBadgeMenu[item.code] ? (
                      <span class="badge badge badge-info badge-pill float-right mr-2">
                        {objBadgeMenu[item.code]}
                      </span>
                    ) : (
                      ""
                    )} */}
                  </a>
                  {item.IsShowCap2 == true && (
                    <ul className="menu-content">
                      {item.lstChild.map((itemSub, index) => (
                        <li
                          key={itemSub.Code + index}
                          className={
                            itemSub.Url == currentURL ? "open active" : ""
                          }
                        >
                          <a className="menu-item" href={itemSub.Url}>
                            <i className={"fas fa-caret-right"}></i>
                            <span className="menu-title">{itemSub.Name} </span>
                            {/* {objBadgeMenu[itemSub.code] ? (
                              <span class="badge badge badge-info badge-pill float-right mr-2">
                                {objBadgeMenu[itemSub.code]}
                              </span>
                            ) : (
                              ""
                            )} */}
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
          </ul>
          <div class="dropdown-divider-menu"></div>
          <span
            class="text-center"
            style={{
              fontSize: "14",
              paddingBottom: "40px",
              textAlign: "center",
              color: "#FFFFFF",
            }}
          >
            <span style={{ marginTop: "20px", display: "block" }}>
              Copyright &copy; 2011 - {year} &nbsp;
              <a
                class="text-bold-800 grey darken-2"
                style={{ color: "#FFF" }}
                href="http://niemtinvn.com"
                target="_blank"
              >
                <u>Niềm Tin</u>{" "}
              </a>
            </span>
            <span style={{ display: "block", paddingBottom: "50px" }}>
              All rights reserved. Phiên bản 8.1
            </span>
          </span>
        </div>
      </div>

      <div className="app-content content">
        <div className="content-wrapper">
          <div className="content-header row"></div>
          <div className="content-body">
            <div id="form-repeater">{props.children}</div>
          </div>
        </div>
      </div>
      {isShowNoti && (
        <ThongBaoCapNhapContainer id={NotiId}></ThongBaoCapNhapContainer>
      )}
      <Footer thongTin={thongTinCuaHang} />
    </Fragment>
  );
};

LayoutV2.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default LayoutV2;
